<div class="mat-typography" (keydown)="onKeyDown($event)">
  <h1 mat-dialog-title i18n>Date Range Selection</h1>
  <div mat-dialog-content>
    <div>
      <mat-form-field appearance="fill">
        <mat-label i18n>Date Range</mat-label>
        <mat-date-range-input
          [min]="data.min"
          [max]="data.max"
          [rangePicker]="picker"
        >
          <input
            matStartDate
            matInput
            placeholder="From Date"
            i18n-placeholder
            [ngModel]="data.from"
            (ngModelChange)="data.from = setDate($event)"
          />
          <input
            matEndDate
            matInput
            placeholder="To Date"
            i18n-placeholder
            [ngModel]="data.to"
            (ngModelChange)="data.to = setDate($event)"
          />
        </mat-date-range-input>
        <mat-datepicker-toggle
          matIconSuffix
          [for]="picker"
        ></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </mat-form-field>
    </div>
    <div class="slider">
      <mat-slider [min]="getTime(data.min)" [max]="getTime(data.max)">
        <input
          matSliderStartThumb
          [value]="getTime(data.from)"
          (valueChange)="data.from = getDate($event)"
        />
        <input
          matSliderEndThumb
          [value]="getTime(data.to)"
          (valueChange)="data.to = getDate($event)"
        />
      </mat-slider>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="false" i18n>Cancel</button>
    <button mat-button [mat-dialog-close]="getParameters()" i18n>OK</button>
  </div>
</div>
